
<div class="responsive-container">
  <bpc-generic-listing [title]="'IC'" [tableClass]="'voting-table'" [columns]="companiesColumns" [companiesFilter]="companiesFilter" [hasPod]="false" [data]="companies" [totalCount]="totalCount" [isLoading]="isLoading" (onFilterChange)="onFilterChange($event)" (onLoadMore)="loadMoreData()">
    <div slot="header-options" class="col flex align-content-center flex-wrap flex-w-auto">
      <div class="col flex align-content-center flex-wrap flex-w-auto">
        <bpc-spreadsheet-download *ngIf="showDownloadSpreadsheet"/>
      </div>
    </div>
    <div slot="subroutes" class="col flex align-content-center flex-wrap flex-w-auto vote-tab-container">
      <ng-container *ngFor="let ef of childTabs" >
        <a class="vote-tab-buttons" [routerLink]="!isMobile ? '/ic/' + ef.route : '/m/ic/' + ef.route" [ngClass]="{ 'active-ic-vote-tab': type === ef.route }" *ngIf="canAccessTab(ef.accessRoles)">
          {{ef.label}}
        </a>
      </ng-container>
    </div>
  </bpc-generic-listing>
    <bpc-voting-stats
    *ngIf="votingService.displayVotingStats && votingService.votingStats"
    [visible]="votingService.displayVotingStats"
    [currentTabIndex]="routerService.currentTabIndex"
    [currentChildIndex]="routerService.currentChildIndex"
  />
  <bpc-comment-section
  [currentTabIndex]="routerService.currentTabIndex"
  [currentChildIndex]="routerService.currentChildIndex"
  />
</div>